import { Box, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ToolLayout } from "../../components/developerTools/ToolLayout";



const TOOLS = [
	{ path: "base64", title: "Base64 Encoder & Decoder", description: "Convert UTF-8 text to and from Base64 for use in text-based systems." },
	{ path: "url", title: "URL Encoder & Decoder", description: "Encode and decode individual URL values using percent encoding." },
	{ path: "hex", title: "Hex Encoder & Decoder", description: "Convert UTF-8 text to hexadecimal bytes and back." },
	{ path: "random-bytes", title: "Secure Random Byte Generator", description: "Create cryptographically secure random bytes in Base64, Hex or Base64URL, entirely on your device." }
];

/** Introduces the on-device utilities and explains how they protect input and output. */
export const DeveloperTools = () => (
	<ToolLayout title="NumaSuite Developer Tools" description="Tools you can trust. Your work stays on your device.">
		<Typography sx={{ maxWidth: "780px", fontSize: "18px", lineHeight: 1.8, mb: 5 }}>
			As a developer-first company, we know how hard it can be to find tools you can trust. You shouldn’t have to wonder where your data goes when you use an encoder or decoder. That’s why we provide our own tools, with a clear guarantee of privacy and safety: your input and output stay on your device.
		</Typography>
		<Box component="section" aria-label="Available tools" sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" }, gap: 3, mb: 5 }}>
			{ TOOLS.map((tool) => (
				<Card key={ tool.path } variant="outlined" sx={{ borderColor: "#d9d5e3", borderRadius: "12px", backgroundColor: "#fff" }}>
					<CardActionArea component={ Link } to={ `/developer/tools/${ tool.path }` } sx={{ height: "100%", "&:hover": { backgroundColor: "#f5f2f9" } }}>
						<CardContent sx={{ p: 3 }}>
							<Typography component="h2" sx={{ fontSize: "22px", fontWeight: 600, color: "#3B0E59", mb: 2 }}>{ tool.title }</Typography>
							<Typography sx={{ lineHeight: 1.7, mb: 3 }}>{ tool.description }</Typography>
							<Typography sx={{ color: "#3B0E59", fontWeight: 600 }}>Open tool →</Typography>
						</CardContent>
					</CardActionArea>
				</Card>
			)) }
		</Box>
		<Box component="section" aria-labelledby="tools-privacy" sx={{ p: { xs: 3, sm: 4 }, borderLeft: "4px solid #3B0E59", borderRadius: "0 12px 12px 0", backgroundColor: "#e4deed" }}>
			<Typography id="tools-privacy" component="h2" sx={{ fontSize: "24px", fontWeight: 600, color: "#3B0E59", mb: 2 }}>Your work stays with you</Typography>
			<Typography sx={{ lineHeight: 1.8, maxWidth: "800px" }}>Every tool runs on your device, in your browser. Nothing you enter or generate is saved by us or processed in the cloud. We never see your input or output, and these pages load no third-party tracking scripts. Copy a result when you need it, or clear the fields when you’re finished.</Typography>
		</Box>
	</ToolLayout>
);
